const reviews = [
  {
    name: "Ismael Vidal Risueño",
    star: 5,
    text: " Venía con miedo, ya que no soy de Marbella y no conocía nada de la ciudad. Pero gracias a Laura todo ha sido mucho más fácil y en tan solo 2 semanas hemos conseguido aprobar el práctico.      Da mucha confianza a la hora de conducir y hace que te sea muy fácil coger confianza en ti mismo para llegar preparado al examen. Totalmente recomendable!!!!!",
  },
  {
    name: "SANTIAGO RICO",
    star: 5,
    text: "La verdad ha sido una experiencia muy positiva, conocí a Laura por internet porque me cambie de autoescuela y fue la mejor decisión que pude tomar. Aprobado a la primera.  Laura es una excelente profesora y persona, la mejor de Marbella.",
  },
  {
    name: "Elena Yurkina",
    star: 5,
    text: "Laura ha sido mi profesora de conduci y le estoy muy agradecida. Tiene mucha paciencia y pasión por su trabajo. Estoy muy contenta de haber dado con ella; sus clases prácticas han sido muy eficientes y sus consejos me han ayudado mucho para aprobar el examen y sentirme cómoda con el coche.",
  },
  {
    name: "Alejandro Coello",
    star: 5,
    text: "Tras suspender el examen práctico en Almería ya que estaba allí por estudios, decidí probar en Marbella, mi ciudad. Un amigo me recomendó esta autoescuela, y sobretodo a la profesora con la cual logré aprobar a la primera. Gracias a Laura por tu tiempo y dedicación que me han ayudado a sacarme el carnet por fin, ha sido un placer. 100% recomendable",
  },
  {
    name: "Consuelo Benítez Pedrosa",
    star: 5,
    text: "Se ha adaptado completamente a mi estilo de vida, siendo flexible en cuanto horarios de clase, además con Laura aprender es rápido, debido a su infinita paciencia y su dinamismo.",
  },
  {
    name: "Marta Fernández Naranjo",
    star: 5,
    text: "Laura es la mejor profesora que podríais tener. Explica todo genial, es muy empática con todos los miedos y dificultades, y es muy entretenida. Pasé de pensar que no me iba a sacar el carné nunca a aprobar el examen a la primera. La recomiendo muchísimo!!",
  },
  {
    name: "Cristina González Ruiz-Moyano",
    star: 5,
    text: "Profesora de diez. Súper atenta, paciente y docente. En mi caso di clases de reciclaje porque llevaba mucho tiempo sin conducir, y Laura me ayudó mucho a recuperar la seguridad al volante. Agradecidísima es poco!☺️",
  },

  {
    name: "Maria Caudeli Otal",
    star: 5,
    text: "Mi experiencia ha sido excelente. No hay mejor profesora que Laura, que fácil te lo hace todo! Gracias❤️",
  },
  {
    name: "Lucía Delgado",
    star: 5,
    text: "Laura fue mi profesora de autoescuela y no pude haber estado más contenta. Me saqué el práctico a la primera y fui muy preparada y segura al examen. Sin duda una profesora de 10!!!!  ",
  },
  {
    name: "Nia Cristina",
    star: 5,
    text: "Me cambié a esta escuela con todos los nervios de que no iba a ser buena conduciendo, pero con la paciencia de Laura pude concentrarme y esforzarme para dar lo mejor en el examen, y eso es lo que pasó, a la primera pasé y todo gracias a Laura, no hay otra autoescuela que recomendaría que no sea esta. Mil gracias por todo Laura!!",
  },
  {
    name: "Rocío García Moreno",
    star: 5,
    text: "Impecable en todos los aspectos. Profesora brillante; sabe explicar lo que debes hacer y tiene mucha paciencia. Además, buenísima persona! Te sentirás muy comodx desde el primer minuto. Muy recomendable",
  },
];

export default reviews;
